import React from "react";
import { styled } from "goober";

import CloseIcon from "@/inline-assets/close.svg";

const ClearContainer = styled("div")`
  --slide-distance: var(--sp-4);

  position: relative;

  display: inline-flex;
  align-items: center;

  &:hover label {
    opacity: 1;

    transform: translateX(var(--slide-distance));
  }
`;

const CloseLabel = styled("label")`
  position: absolute;
  left: calc(-100% - var(--slide-distance) * 2);

  display: flex;
  align-items: center;

  padding: var(--sp-0_5) var(--sp-3);

  border-radius: var(--br-xl);

  user-select: none;
  pointer-events: none;

  transition: var(--transition);
  opacity: 0;
  /* The slide-out animation on button hover */
  transform: translateX(0);
`;

const CloseButton = styled("button")`
  margin-left: var(--sp-2);
  width: var(--sp-8);
  padding: var(--sp-0_5); /* Slightly expand the clickable area */

  color: var(--shade2);
  background-color: transparent;

  cursor: pointer;
`;

const ClearModule = ({ onClick, label }) => {
  return (
    <ClearContainer>
      <CloseLabel className={`type-body2`}>{label}</CloseLabel>

      <CloseButton onClick={onClick} tabIndex={-1} aria-label={label}>
        <CloseIcon />
      </CloseButton>
    </ClearContainer>
  );
};

export default ClearModule;
